export const getSquares = (state) => state?.squares || [];
export const getMissions = (state) => state?.missions || [];
